export default __webpack_public_path__ + "/img/whatsapp-smokin.webp";